import { render, staticRenderFns } from "./InterfaceInfo.vue?vue&type=template&id=0fd27f76&scoped=true&"
import script from "./InterfaceInfo.vue?vue&type=script&lang=ts&"
export * from "./InterfaceInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd27f76",
  null
  
)

export default component.exports